import React, { useLayoutEffect, useRef } from "react";
import ChatBubble from "../../../../component/chat-bubble";
import { Box, styled } from "@mui/material";
import { Message } from "../../../../api/message-request";
import { useCurrentUser } from "../../../../api-hooks/use-current-user";
import { useSelectedUser } from "../../../../api-hooks/use-selected-user";

type ChatDetailMessagesProps = {
  messages: Message[];
};

const StyledContainer = styled(Box)(() => ({
  padding: "1rem",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  height: "calc(80vh - 80px)",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  msOverflowStyle: "none", // For Internet Explorer 10+
  scrollbarWidth: "none", // For Firefox
}));

const ChatDetailMessages: React.FC<ChatDetailMessagesProps> = ({
  messages,
}) => {
  const { user: loginUser } = useCurrentUser();
  const { selectedUser } = useSelectedUser();
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [selectedUser, messages]);

  return (
    <StyledContainer ref={scrollRef}>
      {messages.map((message) => (
        <ChatBubble
          key={message?.id}
          message={message.text}
          isSender={loginUser?.id === message.senderId}
          date={new Date(message.sendAt ?? "")}
        />
      ))}
    </StyledContainer>
  );
};

export default ChatDetailMessages;
